import React from 'react'

import { color } from './style'

function Error({ message }) {
  return <div style={{ color: color.error, margin: '1em auto' }}>{message}</div>
}

export default Error
